export const LAST_UPDATED = '2021-07-01';
